@if (isLoadingResults) {
  <div class="example-loading-shade" style="z-index: 99999">
    @if (isLoadingResults) {
      <mat-spinner [style.zoom]="1"></mat-spinner>
    }
  </div>
}
<div cdkDrag class="popup_main_div generrate_document_main" cdkDragRootElement=".cdk-overlay-pane">
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    @if (!isGenerating) {
      <span>Synced To Xero</span>
    }
    @if (isGenerating) {
      <span>Syncing To Xero</span>
    }
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main" fxLayout="column">
    @if (isLoadingResults) {
      <div style="position: relative; z-index: 99999">
        <h3>
          <strong>It will take a while for the sync process to complete.</strong>
        </h3>
        <br />
        <div style="position: relative; width: 100%; margin-top: 16px">
          <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
        </div>
        <div style="margin-top: 12px">
          <h3>{{ btnText }}</h3>
        </div>
      </div>
    }
    <div
      class="one"
      style="width: 100%"
      fxLayout="column"
      fxLayoutAlign="start"
      fxLayout.gt-md="row"
      fxFlex="1 0 auto"
    >
      @if (IsAuth) {
        <div style="width: 100%">
          <div fxFlex="80" class="middle" fxLayoutAlign="start">
            <span>
              Please login to your Xero account. Once completed, please click on try again
            </span>
          </div>
          <div fxFlex="20">
            <button
              mat-raised-button
              color="accent"
              class="mat-accent"
              selectMatter
              (click)="syncToXero()"
            >
              Click Here to Login
            </button>
          </div>
        </div>
      }
      <!-- @if (!IsAuth && !isError) {
                <div>
                    <div
                        fxFlex="100"
                        fxLayoutAlign="start"
                    >
                        <h3>
                            <strong>{{ btnText }}</strong>
                        </h3>
                    </div>
                </div>
            } -->
      @if (isError) {
        <span style="width: 100%">
          @for (item of errorData; track item) {
            <div fxLayoutAlign="start">
              <h3 fxFlex="25">
                <strong>{{ item?.ERRORTYPE }}:</strong>
              </h3>
              <h3 fxFlex="75">
                <strong>{{ item?.MESSAGE }}</strong>
              </h3>
              <hr />
            </div>
          }
        </span>
      }
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button
      matButton="tonal"
      [mat-dialog-close]="false"
      [disabled]="isLoadingResults"
      cdkFocusInitial
    >
      Cancel
    </button>
  </mat-dialog-actions>
</div>
